import { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import ThemeConfigContext from '../../theming/contexts/ThemeConfigContext';
import ThemeContext from '../../theming/contexts/ThemeContext';
import ThemeProvider from '../../theming/providers/ThemeProvider';
import { PrimaryMessageAvatarWrapper } from './PrimaryMessageAvatar';
import { PrimaryMessageContentWrapper } from './PrimaryMessageContent';
import { PrimaryMessageFooterWrapper } from './PrimaryMessageFooter';
import { MESSAGE_AVATAR_OFFSET_PX, MESSAGE_MIN_WIDTH_PX, MESSAGE_SPACING_HORIZONTAL_PX, MESSAGE_SPACING_VERTICAL_PX, SPOTLIGHT_WRAPPER_PADDING_PX } from './messageDimensions';
import { PrimaryMessageHeaderWrapper } from './PrimaryMessageHeader';
import { PrimaryMessageHeaderContentWrapper } from './PrimaryMessageHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";
const AVATAR_MARGIN = '8px';
const withAvatarStyles = css(["padding-left:", ";", "{", "{width:", ";margin-left:-", ";margin-right:", ";}>:first-child{&", "{margin-left:", ";}}}", "{margin-left:", ";}", "{margin-left:", ";width:max( calc(100% - ", "px),", "px );}"], AVATAR_MARGIN, PrimaryMessageHeaderWrapper, PrimaryMessageAvatarWrapper, ({
  avatarWidth
}) => avatarWidth, AVATAR_MARGIN, AVATAR_MARGIN, PrimaryMessageHeaderContentWrapper, ({
  avatarWidth
}) => avatarWidth, PrimaryMessageContentWrapper, ({
  avatarWidth
}) => avatarWidth, PrimaryMessageFooterWrapper, ({
  avatarWidth
}) => avatarWidth, MESSAGE_AVATAR_OFFSET_PX, MESSAGE_MIN_WIDTH_PX);
const withoutAvatarStyles = css(["align-items:stretch;", "{display:none;}", "{display:flex;margin-left:0;max-width:100%;padding:2px ", "px;&:focus-visible{background-color:transparent;}}", "{margin-left:0;padding-left:", "px;width:100%;}"], PrimaryMessageHeaderWrapper, PrimaryMessageContentWrapper, SPOTLIGHT_WRAPPER_PADDING_PX, PrimaryMessageFooterWrapper, SPOTLIGHT_WRAPPER_PADDING_PX);
const PrimaryMessageWrapper = styled.div.withConfig({
  displayName: "PrimaryMessage__PrimaryMessageWrapper"
})(["display:flex;flex-direction:column;align-items:", ";", ""], ({
  alignment
}) => alignment || 'flex-start', ({
  $showAvatar
}) => $showAvatar ? withAvatarStyles : withoutAvatarStyles);
const SpacingWrapper = styled.div.withConfig({
  displayName: "PrimaryMessage__SpacingWrapper"
})(["padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;width:100%;"], MESSAGE_SPACING_VERTICAL_PX, MESSAGE_SPACING_VERTICAL_PX, ({
  $horizontalPadding
}) => $horizontalPadding, ({
  $horizontalPadding
}) => $horizontalPadding);
export default class PrimaryMessage extends PureComponent {
  render() {
    const {
      children,
      className,
      use
    } = this.props;
    return children ? /*#__PURE__*/_jsx(ThemeProvider, {
      themeConfig: this.context,
      use: use,
      children: /*#__PURE__*/_jsx(ThemeContext.Consumer, {
        children: ({
          alignItems,
          avatarWidth,
          messageHorizontalPadding = MESSAGE_SPACING_HORIZONTAL_PX,
          showAvatar = true
        }) => /*#__PURE__*/_jsx(SpacingWrapper, {
          className: className,
          $horizontalPadding: messageHorizontalPadding,
          "data-test-id": "spacing-wrapper",
          children: /*#__PURE__*/_jsx(PrimaryMessageWrapper, {
            "data-test-id": this.props['data-test-id'],
            "data-test-use": use,
            alignment: alignItems,
            avatarWidth: avatarWidth,
            $showAvatar: showAvatar,
            children: children
          })
        })
      })
    }) : null;
  }
}
PrimaryMessage.displayName = 'PrimaryMessage';
PrimaryMessage.contextType = ThemeConfigContext;